import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import OidcService from 'services/OidcService';
import App from 'modules/App';
import Account from 'modules/Account';
import { LoaderLayout, MobileLoaderLayout } from 'modules/Layout';
async function action({ route, query, store }) {
    if (process.env.BROWSER) {
        if (query.code) {
            try {
                await OidcService.loginCallback();
            } catch (err) {
                await OidcService.login();
            }
            try {
                await store.dispatch(App.actions.setRegionFromToken()).catch(()=>{});
                await store.dispatch(Account.actions.getMe()).catch(()=>{});
            } catch (err) {
            // handle in saga
            }
        } else {
            await OidcService.login();
        }
    }
    const state = store.getState();
    const isMobileDisplayMode = App.selectors.isMobileDisplayMode(state);
    const Loader = isMobileDisplayMode ? MobileLoaderLayout : LoaderLayout;
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        component: /*#__PURE__*/ _jsx(Loader, {})
    };
}
export default action;
